module.exports = __webpack_public_path__ + "static/img/nawiWstecz-ON.26dc9469.png";